"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.interceptAxios = exports.getCaptcha = exports.handleLogout = exports.prepareAccess = exports.getGlobalNamespace = exports.overwriteGlobalNamespace = void 0;
/* istanbul ignore next */
var pick_1 = __importDefault(require("lodash/pick"));
var passport_1 = __importDefault(require("./passport"));
var interceptor_1 = __importDefault(require("./interceptor"));
var globalNamespace_1 = require("./globalNamespace");
Object.defineProperty(exports, "getGlobalNamespace", { enumerable: true, get: function () { return globalNamespace_1.getGlobalNamespace; } });
Object.defineProperty(exports, "overwriteGlobalNamespace", { enumerable: true, get: function () { return globalNamespace_1.overwriteGlobalNamespace; } });
var constants_1 = require("./constants");
var utils_1 = require("./utils");
function initialize(options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((0, globalNamespace_1.getGlobalNamespace)().singletonPassport) {
                        console.warn('Passport installed multi times');
                        return [2 /*return*/, (0, globalNamespace_1.getGlobalNamespace)().singletonPassport];
                    }
                    (0, globalNamespace_1.getGlobalNamespace)().singletonPassport = new passport_1.default(options.clientId, options.clientName, (0, pick_1.default)(options, [
                        'baseAuthServer',
                        'storeKeyPrefix',
                        'accessTokenExpiredMS',
                        'refreshTokenExpiredMS',
                    ]));
                    // 给拦截器用的
                    (0, globalNamespace_1.getGlobalNamespace)().passportRuntimeOptions = {
                        redirectToLogin: options.redirectToLogin || (function () { }),
                        onTokenRefresh: options.onTokenRefresh || (function () { }),
                        detectResponseAsUnauthorized: options.detectResponseAsUnauthorized || (function () { return false; }),
                        onPaymentRequired: options.onPaymentRequired || (function () {
                            console.error('onPaymentRequired not implemented', (0, globalNamespace_1.getGlobalNamespace)().passportRuntimeOptions);
                            throw new Error('onPaymentRequired is required!');
                        }),
                    };
                    if (options.axiosAdapter) {
                        (0, globalNamespace_1.getGlobalNamespace)().singletonPassport.requester.defaults.adapter =
                            options.axiosAdapter;
                    }
                    if (options.localStorageLikeStore) {
                        (0, globalNamespace_1.getGlobalNamespace)().singletonPassport.localStorageLikeStore =
                            options.localStorageLikeStore;
                    }
                    if (typeof options.onTokenSessionMissMatchHook === 'function') {
                        (0, globalNamespace_1.getGlobalNamespace)().singletonPassport.onTokenSessionMissMatchHook = options.onTokenSessionMissMatchHook;
                    }
                    if (typeof options.afterStoreToken === 'function') {
                        (0, globalNamespace_1.getGlobalNamespace)().singletonPassport.afterStoreToken = options.afterStoreToken;
                    }
                    if (typeof options.syncTokenParamsModifier === 'function') {
                        (0, globalNamespace_1.getGlobalNamespace)().singletonPassport.syncTokenParamsModifier =
                            options.syncTokenParamsModifier;
                    }
                    if ((0, globalNamespace_1.getGlobalNamespace)().interceptor) {
                        // tslint:disable-next-line:max-line-length
                        (0, globalNamespace_1.getGlobalNamespace)().interceptor.options = (0, globalNamespace_1.getGlobalNamespace)().passportRuntimeOptions;
                        (0, globalNamespace_1.getGlobalNamespace)().interceptor.passport = (0, globalNamespace_1.getGlobalNamespace)().singletonPassport;
                    }
                    if (options.autoRun !== undefined && !options.autoRun) {
                        return [2 /*return*/, (0, globalNamespace_1.getGlobalNamespace)().singletonPassport];
                    }
                    return [4 /*yield*/, prepareAccess([constants_1.ERROR_TYPE.AUTH, constants_1.ERROR_TYPE.PAYMENT])];
                case 1:
                    _a.sent();
                    return [2 /*return*/, (0, globalNamespace_1.getGlobalNamespace)().singletonPassport];
            }
        });
    });
}
exports.default = initialize;
function prepareAccess(breakOnErrorTypes) {
    if (breakOnErrorTypes === void 0) { breakOnErrorTypes = [constants_1.ERROR_TYPE.AUTH, constants_1.ERROR_TYPE.PAYMENT]; }
    return __awaiter(this, void 0, void 0, function () {
        var e_1, d;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 12]);
                    return [4 /*yield*/, (0, globalNamespace_1.getGlobalNamespace)().singletonPassport.getAccessToken()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 12];
                case 2:
                    e_1 = _a.sent();
                    console.error('[prepareAccess] error:', e_1);
                    if (!(e_1.passportErrorType === constants_1.ERROR_TYPE.PAYMENT)) return [3 /*break*/, 5];
                    return [4 /*yield*/, (0, globalNamespace_1.getGlobalNamespace)().passportRuntimeOptions.onPaymentRequired(e_1)];
                case 3:
                    _a.sent();
                    (0, globalNamespace_1.getGlobalNamespace)().singletonPassport.expireToken('token');
                    return [4 /*yield*/, (0, utils_1.waitJumpout)()];
                case 4:
                    _a.sent();
                    if (breakOnErrorTypes.includes(constants_1.ERROR_TYPE.PAYMENT)) {
                        throw e_1;
                    }
                    return [3 /*break*/, 11];
                case 5:
                    if (e_1.passportErrorType !== constants_1.ERROR_TYPE.AUTH) {
                        console.error('Unknown passport error:', e_1); // 不应出现其他错误
                    }
                    return [4 /*yield*/, (0, globalNamespace_1.getGlobalNamespace)().passportRuntimeOptions.redirectToLogin(e_1)];
                case 6:
                    d = _a.sent();
                    if (!(d && ('token' in d && d.refreshToken))) return [3 /*break*/, 8];
                    return [4 /*yield*/, (0, globalNamespace_1.getGlobalNamespace)().singletonPassport.updateTokensFromOutSide(d.token, d.refreshToken)];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 11];
                case 8:
                    if (!(d && 'resetRetardation' in d && d.resetRetardation === true)) return [3 /*break*/, 9];
                    return [2 /*return*/, Promise.reject({ resetRetardation: true })];
                case 9: return [4 /*yield*/, (0, utils_1.waitJumpout)()];
                case 10:
                    _a.sent();
                    if (breakOnErrorTypes.includes(constants_1.ERROR_TYPE.AUTH)) {
                        throw e_1;
                    }
                    _a.label = 11;
                case 11: return [3 /*break*/, 12];
                case 12: return [2 /*return*/];
            }
        });
    });
}
exports.prepareAccess = prepareAccess;
function handleLogout() {
    return (0, globalNamespace_1.getGlobalNamespace)().singletonPassport.logout();
}
exports.handleLogout = handleLogout;
function getCaptcha(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (0, globalNamespace_1.getGlobalNamespace)().singletonPassport.getCaptcha(params)];
        });
    });
}
exports.getCaptcha = getCaptcha;
function interceptAxios(requester) {
    var _this = this;
    if (!(0, globalNamespace_1.getGlobalNamespace)().interceptor) {
        (0, globalNamespace_1.getGlobalNamespace)().interceptor = new interceptor_1.default((0, globalNamespace_1.getGlobalNamespace)().singletonPassport, (0, globalNamespace_1.getGlobalNamespace)().passportRuntimeOptions);
    }
    var passportRequestInterceptor = requester.interceptors.request.use(function (config) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(0, globalNamespace_1.getGlobalNamespace)().interceptor.clientUnauthorized) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, globalNamespace_1.getGlobalNamespace)().interceptor.promise()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    config.headers.Authorization = "Bearer ".concat((0, globalNamespace_1.getGlobalNamespace)().singletonPassport.getToken('token'));
                    return [2 /*return*/, config];
            }
        });
    }); });
    /**
     * We will never handle success http request.
     * But you can write your own interceptor in your project to
     * throw error when your api response with a special body.
     * Remember to use the same structure as AxiosError, for example:
     *
     * import { get } from 'lodash'
     *
     * axios.interceptors.response.use(function (response) {
     *  if (get(res, 'data.errorCode') === '10024') {
     *    throw Object.assign(new Error('unauthorized'), {
     *      response: res,
     *      config: res.config,
     *      code: res.statusText,
     *      request: res.request,
     *    })
     *  }
     *  return res
     * })
     */
    var passportResponseInterceptor = requester.interceptors.response.use(null, function (error) {
        return (0, globalNamespace_1.getGlobalNamespace)().interceptor.processRespond(error, requester);
    });
    // @ts-ignore
    if (requester.psInterceptors) {
        // @ts-ignore
        requester.psInterceptors = __assign(__assign({}, requester.psInterceptors), { passportRequestInterceptor: passportRequestInterceptor, passportResponseInterceptor: passportResponseInterceptor });
    }
    return { passportRequestInterceptor: passportRequestInterceptor, passportResponseInterceptor: passportResponseInterceptor };
}
exports.interceptAxios = interceptAxios;
//# sourceMappingURL=index.js.map